import {trackAmplitudeEvent} from "@pg-mono/amplitude";

type LogoutPlacement = "km";

interface ITrackAmplitudeLoggedOutParams {
    logoutPlacement: LogoutPlacement;
}

export const trackAmplitudeLoggedOut = (params: ITrackAmplitudeLoggedOutParams) => {
    trackAmplitudeEvent("logged_out", {
        logout_placement: params.logoutPlacement
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

type LogoutPlacement = "km";

interface ITrackAmplitudeLoggedOutParams {
    logoutPlacement: LogoutPlacement;
}

export const trackAmplitudeLoggedOut = (params: ITrackAmplitudeLoggedOutParams) => {
    trackAmplitudeEvent("logged_out", {
        logout_placement: params.logoutPlacement
    });
};
